import MaterialTable, { Column } from 'material-table';
import moment from 'moment';
import React, { useMemo, useCallback } from 'react';
import { Deal } from '~/features/dashboard/store/models';
import { useLocalizedCurrency } from '~/utils/hooks/useLocalizedCurrency';
import css from './styles.module.scss';
import { Typography } from '@material-ui/core';
import Avatar from '@material-ui/core/Avatar';
import AvatarGroup from '@material-ui/lab/AvatarGroup';
import { useDispatch } from 'react-redux';
import { isDealFormEditing } from '~/features/dashboard/store/actions';
import { goToEditDealThunk } from '~/features/dashboard/store/actions.thunks';
import { useRouteMatch } from 'react-router-dom';
import { useAppRoute } from '~/utils/hooks/useAppRoute';
import { VerticalPopver } from '~/features/dashboard/components/vertical-popover';
import { useSelector } from 'react-redux';
import { selectUserData } from '~/features/dashboard/store/selectors';
import { useDateFormat } from '~/common/date-format';
interface DealsProps {
    deals: Deal[];
}
// const handleDownloadClick = async (id: any) => {
//     DealApi.exportDealDetails(id).then(response => {
//         const url = window.URL.createObjectURL(new Blob([response.data], { type: response.headers['content-type'].split('; ')[0] }));
//         const link = document.createElement('a');
//         link.href = url;
//         link.target = '_blank';
//         link.download = 'download.zip';
//         link.click();
//         window.URL.revokeObjectURL(url);
//         link.remove();
//     });
// };
const ActionsCell: React.FC<{ data: Deal }> = ({ data }) => {
    const dispatch = useDispatch();
    const route = useAppRoute();

    const editDealForm = useCallback(() => {
        dispatch(isDealFormEditing(true));
        dispatch(goToEditDealThunk({ assetCode: data.assetCode }));
    }, [data.assetCode, dispatch]);

    const match = useRouteMatch<{ creatorId: string }>();

    const dealDetailsRoute = useMemo(() => `${match.url}/${data.assetCode}/details`, [match.url, data.assetCode]);

    const goToDealDetails = useCallback(() => route(dealDetailsRoute), [dealDetailsRoute, route]);

    return (
        <div className={css.actionsCell}>
            <VerticalPopver childClassName={''} actionsList={`edit,view`} onClickEdit={() => editDealForm()} onClickView={() => goToDealDetails()} />
        </div>
    );
};

const BalanceCell: React.FC<{ balance: number | null; balanceCurrency: string }> = ({ balance, balanceCurrency }) => {
    const balanceContent = useLocalizedCurrency(balance, balanceCurrency);

    return <>{balanceContent}</>;
};

const getTableEntityFromDeal = (data: Deal, Users: any, formatDate: (date: Date | string) => string) => {
    const { contractBalance, incomePeriod, dealType, incomeType, statementDate, title, image } = data;

    const userDeatils = Users?.contacts.filter((person: any) => person.contactCode === data.companyContactCode);

    // const defaultAdrress = {
    //     companyName: '',
    //     addressLine1: '',
    //     addressLine2: '',
    //     addressLine3: '',
    //     addressLine4: '',
    // };
    const company = userDeatils?.length ? userDeatils[0].companyName : '';

    return {
        company,
        dealType,
        incomeType,
        incomePeriod: incomePeriod
            ? `${formatDate(incomePeriod.start)} - ${formatDate(incomePeriod.end)}`
            : //   `${(<DateFormat newDate={new Date('01-01-2020')} />)} - ${(<DateFormat newDate={incomePeriod.end} />)}`
              null,
        statementDate: statementDate ? `${formatDate(statementDate)}` : null,
        contractBalance: contractBalance,
        entity: data,
        title,
        image,
    };
};

const getTableColumn = <T extends ReturnType<typeof getTableEntityFromDeal>>(): Column<T>[] => {
    return [
        {
            field: 'company',
            title: 'Company',

            render: rowData => {
                return (
                    <div>
                        <div className={css.topOuter}>
                            <AvatarGroup className={'avatars-group'} max={3}>
                                {rowData.image ? (
                                    <Avatar className={css.avatarCustomimg} alt={rowData.title} src={rowData.image} />
                                ) : (
                                    <Avatar className={css.avatarCustomimg} alt={rowData.company} src={rowData.image} />
                                )}
                            </AvatarGroup>
                            {/* <Tooltip title={`${rowData.title} - ${rowData.company}`}>
                                <Typography className={css.companyName}>{`${rowData.title} \n\n ${
                                    // rowData.company.length > 5 ? rowData.company.slice(0, 5) + '...' : rowData.company
                                    rowData.company
                                }`}</Typography>
                            </Tooltip> */}
                            <div>
                                <Typography className={css.companyName}>{`${rowData?.title}`}</Typography>

                                <Typography className={css.companyName} style={{ fontSize: '14px' }}>{`${rowData?.company}`}</Typography>
                            </div>
                        </div>
                    </div>
                );
            },
        },
        {
            field: 'dealType',
            title: 'Deal Type',
        },
        {
            field: 'incomeType',
            title: 'Income Type',
        },
        {
            field: 'incomePeriod',
            title: 'Income Period',
            customSort: (data1, data2) => moment(data1.entity.incomePeriod?.start).diff(data2.entity.incomePeriod?.start),
        },
        {
            field: 'statementDate',
            title: 'Statement Date',
            customSort: (data1, data2) => moment(data1.statementDate).diff(data2.statementDate),
        },
        {
            field: 'balance',
            title: 'Balance',
            render: data => <BalanceCell balance={data.contractBalance} balanceCurrency={data.entity.balanceCurrency} />,
        },
        {
            field: 'entity',
            title: 'Action',
            render: data => <ActionsCell data={data.entity} />,
            filtering: false,
        },
    ];
};

export const DealsList: React.FC<DealsProps> = ({ deals }) => {
    const columns = useMemo(() => getTableColumn(), []);
    console.log(deals);

    const Users = useSelector(selectUserData);
    const { formatDate } = useDateFormat();
    const data = useMemo(() => deals.map(deal => getTableEntityFromDeal(deal, Users, formatDate)), [Users, deals, formatDate]);
    const defaultOptions = useMemo(
        () => ({
            filtering: false,
            paging: false,
        }),
        []
    );

    return (
        <div className={css.module}>
            <MaterialTable data={data} title={''} columns={columns} options={defaultOptions} />
        </div>
    );
};
